import { z } from 'zod';

/** 모델 id — pricing.models[].id (동적, 어드민이 추가·비활성화. 어드민 설계 10절 B4). 1차 시드는 knock·break */
export const ModelId = z.string().regex(/^[a-z][a-z0-9_]{1,31}$/, 'a-z 로 시작, a-z 0-9 _ 2~32자');
export type ModelId = z.infer<typeof ModelId>;

export const ConsentCode = z.enum(['tos', 'privacy', 'ai', 'marketing', 'night_marketing']);
export type ConsentCode = z.infer<typeof ConsentCode>;

export const MessageStatus = z.enum(['pending', 'complete', 'failed']);
export type MessageStatus = z.infer<typeof MessageStatus>;

export const MessageRole = z.enum(['user', 'character']);
export type MessageRole = z.infer<typeof MessageRole>;

export const BlockType = z.enum(['text', 'image', 'dialogue', 'thought', 'scene']);
export type BlockType = z.infer<typeof BlockType>;

export const LotSource = z.enum(['welcome', 'purchase', 'admin', 'coupon', 'event', 'attendance', 'invite', 'bonus']); // bonus = 상품 보너스(같은 purchase 의 무료 로트, AC0-290)
export type LotSource = z.infer<typeof LotSource>;

/** products.badge 코드. 문구는 클라 로케일 파일(코드→문구 매핑), 운영은 ops set-badge 로 상품에 붙인다. 첫 결제 특가 배지는 코드가 아니라 firstPurchaseOnly 에서 파생 */
export const ProductBadge = z.enum(['popular']);
export type ProductBadge = z.infer<typeof ProductBadge>;

export const TxKind = z.enum(['grant', 'spend', 'refund', 'expire', 'revoke']);
export type TxKind = z.infer<typeof TxKind>;

export const UserStatus = z.enum(['active', 'blocked', 'pending']); // pending = 온보딩 미완료(account-deletion 결정 10). deleted 는 API 로 나가지 않는다(401)
export type UserStatus = z.infer<typeof UserStatus>;

export const Platform = z.enum(['android', 'ios', 'web']);
export type Platform = z.infer<typeof Platform>;

/** 네이티브 바이너리 플랫폼. OTA `updates`·`native_builds` 와 플랫폼별 `min_build`·`store_url` 키 */
export const NativePlatform = z.enum(['android', 'ios']);
export type NativePlatform = z.infer<typeof NativePlatform>;

/** 요청 헤더 `X-Client`. 토큰 전달 방식(Bearer·Cookie)만 고르고 권한 판단에는 쓰지 않는다 (auth-session 2절) */
export const ClientKind = z.enum(['android', 'ios', 'web']);
export type ClientKind = z.infer<typeof ClientKind>;

/** 로그인 제공자 (auth-session 3.6 · 3.8). 같은 사람이 둘로 로그인하면 계정 2개, 연결은 범위 밖 */
export const AuthProvider = z.enum(['google', 'apple']);
export type AuthProvider = z.infer<typeof AuthProvider>;

export const Env = z.enum(['dev', 'prod']);
export type Env = z.infer<typeof Env>;

export const NoticeType = z.enum(['refund_revoked', 'blocked']);
export type NoticeType = z.infer<typeof NoticeType>;

/** 상품 플랫폼 (products.platform). 상점 API 는 X-Client android→google · ios→apple · web→web (어드민 설계 10절 B2) */
export const ProductPlatform = z.enum(['google', 'apple', 'web']);
export type ProductPlatform = z.infer<typeof ProductPlatform>;
